import { render, staticRenderFns } from "./Allotment.vue?vue&type=template&id=238a841d&scoped=true&"
import script from "./Allotment.vue?vue&type=script&lang=js&"
export * from "./Allotment.vue?vue&type=script&lang=js&"
import style0 from "./Allotment.vue?vue&type=style&index=0&id=238a841d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a841d",
  null
  
)

export default component.exports